import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const ViewProviderAcceptPatient = ({ office }) => {
  const { t } = useTranslation();

  return (
    <div>
      {office?.acceptsNewPatient == "N" && (
        <span className="details-subheader">{t(`acceptsNewPatient`)} </span>
      )}
      {office?.acceptsNewPatient == "N" && (
        <span style={{ color: "#000" }}> {t(`no`)}</span>
      )}

      {office?.acceptsNewPatient == "Y" && (
        <span className="details-subheader">{t(`acceptsNewPatient`)} </span>
      )}
      {office?.acceptsNewPatient == "Y" && (
        <span style={{ color: "#000" }}> {t(`yes`)}</span>
      )}
    </div>
  );
};

ViewProviderAcceptPatient.propTypes = {
  office: PropTypes.object,
};

export default ViewProviderAcceptPatient;
